import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchJson } from '../lib/http';
import { SessionProvider, useSession } from '../state/SessionContext';

function Inner({ children }: { children: React.ReactNode }) {
	const [loading, setLoading] = useState(true);
	const [unavailable, setUnavailable] = useState(false);
	const { setSession } = useSession();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		let cancelled = false;
		(async () => {
			// Bypass auth bootstrap on public portal routes
			const p = location.pathname;
			if (
				p === '/custportal/login' ||
				p.startsWith('/custportal/activate') ||
				p.startsWith('/custportal/set-credentials')
			) {
				setLoading(false);
				return;
			}
			setLoading(true);
			setUnavailable(false);
			try {
				const data = await fetchJson<{ customerId: string; businessId: string; emailVerified: boolean }>('/portal/me');
				if (!cancelled) {
					setSession({ customerId: data.customerId, businessId: data.businessId, emailVerified: data.emailVerified });
										// If user is at /custportal root and authenticated, move to dashboard
						if (location.pathname === '/custportal') {
							navigate('/custportal/dashboard', { replace: true });
						}
				}
			} catch (e: any) {
				if (e?.status === 401 || e?.status === 403) {
					if (
						location.pathname !== '/custportal/login' &&
						!location.pathname.startsWith('/custportal/activate') &&
						!location.pathname.startsWith('/custportal/set-credentials')
					) {
						navigate('/custportal/login', { replace: true });
					}
				} else if (e?.status === 404) {
					setUnavailable(true);
					navigate('/custportal/unavailable', { replace: true });
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => { cancelled = true; };
	}, [navigate, location.pathname, setSession]);

	if (loading) {
		return (
			<main className="mx-auto max-w-2xl px-6 lg:px-8 py-8">
				<div className="rounded-2xl border border-gray-200 bg-white shadow-sm elev-1 p-6">
					<div className="h-5 w-40 bg-gray-100 rounded animate-pulse" aria-hidden />
					<div className="mt-4 space-y-2">
						<div className="h-3 w-3/4 bg-gray-100 rounded animate-pulse" />
						<div className="h-3 w-2/3 bg-gray-100 rounded animate-pulse" />
					</div>
				</div>
			</main>
		);
	}

	if (unavailable) {
		return children as any;
	}

	return children as any;
}

export function MeBootstrap({ children }: { children: React.ReactNode }) {
	return (
		<SessionProvider>
			<Inner>{children}</Inner>
		</SessionProvider>
	);
} 